import * as React from "react";

class DimensionPopover extends React.Component<any, any> {
  render() {
    return (
      <div className="dimension-popover">
        <p>
          <strong>Groupings:</strong> Are used to let you group data. For
          example
          <br />
          if you would like to see data daily, select the "Date" dimension.
          Choosing multiple
          <br />
          groupings will group the data multiple times. For example, selecting
          date and flyer
          <br />
          will give you daily metrics for each flyer.
        </p>
      </div>
    );
  }
}

export default DimensionPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportStructure/DimensionPopover.tsx